import { ProjectFormCreationProps } from "@/interfaces/project_types";
import { z } from "zod";
import { ProjectFormSchema } from "../Interface/DefaultSchema";

/** Converts the schema to an object that will used to send to the API */
export function formatProjectData(data: z.infer<typeof ProjectFormSchema>, project_id?: string) {
    const project_data: ProjectFormCreationProps = {
        project_id: project_id ?? "",
        project_name: data.project_name,
        start_date: data.start_date ?? new Date().toISOString(),
        end_date: data.end_date || undefined,
        follow_up_date: data.follow_up_date ?? undefined,
        manager: data.manager?.value ?? "",
        client_name: data.client_name?.label ?? "",
        city: data.city?.value ?? "",
        template: data.template?.value ?? "3P",
        status: data.status?.value ?? "Active",
        isDeadline: data.isDeadline,
        description: data.description ?? "",
        point_of_contact: data.point_of_contact?.label ?? "",
        no_date_due: data.no_date_due ?? false,
        project_size: data.project_size ?? 0,
        consulting_fee: data.consulting_fee ?? 0,
        folder_location: data.folder_location ?? "",
    }

    return project_data
}